module.exports = __webpack_public_path__ + "img/044.56110f57.svg";